export default __webpack_public_path__ + "static/media/project18.ee78be42.jpg";